import { useState } from "react";

export const useGuidedTour = () => {
  const [runTour, setRunTour] = useState(false);
  const [tourStepIndex, setTourStepIndex] = useState(0);
  const [isSecondTour, setIsSecondTour] = useState(false);

  return {
    runTour,
    setRunTour,
    tourStepIndex,
    setTourStepIndex,
    isSecondTour,
    setIsSecondTour,
  };
};
